<template>
  <div class="animated fadeIn">
    <!--<div class="row pageinfo">
      <b-col lg="6">
        <h2>Locations Indicators</h2>
      </b-col>
      <b-col lg="6"> </b-col>
    </div>  -->
    <div>
      <b-row v-if="loadingData">
        <b-col cols="12" sm="12" md="12" lg="12">
          <p class="text-center">
            <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br />Loading
            data...
          </p>
        </b-col>
      </b-row>
      <div v-else>
        <Container
          @drop="e => onCardDrop('col', e)"
          group-name="col"
          @drag-start="e => log('drag start', e)"
          @drag-end="e => log('drag end', e)"
          :get-child-payload="getCardPayload('column.id')"
          :should-accept-drop="shouldAcceptDropDesktop"
          :should-animate-drop="shouldAnimateDropDesktop"
          drag-class="card-ghost"
          drop-class="card-ghost-drop"
          class="location-widget p-1 mb-4"
          v-if="no_detail"
        >
          <!--Draggable-->
          <!--- code here --->
            <div class="card location-widget mb-4 animated fadeIn">
              <div card-header location-widget-header>
             <!---   <div class="d-flex justify-content-between">
                  <div class="card-body card-border m-0 p-2">
                    <div class="location-widget-chart">--->
                      <highcharts
                            :options="chart_options()"
                            class="chart-container"
                          >
                      </highcharts>
                <!---    </div>
                  </div>
                </div>--->
              </div>
            </div>
          <!--- end code here --->

          <div

            v-for="(location, index) in locacations_data.locations"
            :key="index + '_draggable'"
          >
            <div class="card location-widget mb-4 animated fadeIn">
              <div class="card-header location-widget-header">
                <div class="d-flex justify-content-between">
                  <span 
                    onmouseover="this.style.cursor='pointer'"
                    v-on:click="detail(index)"
                  class="location-widget-title">{{ location.name }} - {{ date_format((location.lastUpdated)) }}
                  </span>
                  <b-badge v-if="location.state!=null"
                    :variant="getStateVariant(location.state)"
                    class="location-state"
                    >{{ location.state }}</b-badge
                  >
                  <b-badge v-else
                    :variant="getStateVariant(location.state)"
                    class="location-state"
                    >{{ "No State"}}</b-badge
                  >
                </div>
              </div>
              <div class="card-body card-border m-0 p-2">
                <div class="location-widget-chart">
                  <highcharts
                    :options="chartOptions(index)"
                    class="chart-container"
                    :ref="'location_chart_' + index"
                  ></highcharts>
                </div>
                <div
                  class="d-flex justify-content-between flex-wrap location-widget-legend mt-4"
                >
                  <div>
                    <b-badge
                      class="legend-badget"
                      style="background-color: #364A8A"
                      >&nbsp;</b-badge
                    >
                    L: {{ location.low }}m<sup>3</sup> / H:
                    {{ location.high }}m<sup>3</sup>
                  </div>
                  <div>
                    <b-badge
                      class="legend-badget"
                      style="background-color: #6FA64B"
                      >&nbsp;</b-badge
                    >
                    EOD: {{ location.eod }}m<sup>3</sup> / 6AM: {{ location.sixAM }}m<sup>3</sup>
                  </div>
                  <div>
                    <b-badge
                      class="legend-badget"
                      style="background-color: #FFD966"
                      >&nbsp;</b-badge
                    >
                    Current: {{ location.current }} m<sup>3</sup>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between flex-wrap location-widget-legend mt-4"
                >
                  <div>
                    <span style="font-weight: bold">Prod:</span><br />
                    {{ location.pro }}m<sup>3</sup>
                  </div>
                  <div>
                    <span style="font-weight: bold">Rem:</span><br />
                    {{ location.rem }}m<sup>3</sup>
                  </div>
                  <div>
                    <span style="font-weight: bold">Hauls:</span><br />
                    {{ location.haulsDelivered }}m<sup>3</sup> /
                    {{ location.haulsRequested }}m<sup>3</sup>
                  </div>
                  <div>
                    <span style="font-weight: bold">HT:</span><br />
                    {{ location.ht }}hr
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between flex-wrap location-widget-legend mt-5"
                >
                  <b-button v-if="view"  class="btn btn-primary" @click="minus(index)">Cut (-)</b-button>
                  <b-button v-if="view" class="btn btn-primary" @click="add(index)">Add (+)</b-button>
                  <b-button v-if="view" class="btn btn-primary" @click="confirm(index)">Confirm</b-button>
                </div>
                <div v-if="location.preview"
                  class="d-flex justify-content-center flex-wrap location-widget-legend mt-5"
                >
                    {{ location.inc }}{{ sign }}{{ location.inc_1 }}
                </div>
              </div>
            </div>
            <b-row>
                  <b-col cols="4">

                  </b-col>
              </b-row>
          </div>
          <!--/Draggable-->
        </Container>
        <Container
          @drop="e => onCardDrop('col1', e)"
          group-name="col1"
          :get-child-payload="getCardPayload('column.id')"
          :should-accept-drop="shouldAcceptDropDesktop"
          :should-animate-drop="shouldAnimateDropDesktop"
          drag-class="card-ghost"
          drop-class="card-ghost-drop"
          class="location-widget p-1 mb-4"
          v-if="!no_detail"
        >
            <div class="card location-widget mb-4 animated fadeIn">
                <div class="card-header location-widget-header">

                    <b-row>
							          <b-col sm=5>
                            <div class="d-flex justify-content-between">
                                <span 
                                    class="location-widget-title">{{ loc.name }} 
                                </span>
                            </div>
                            <br />
                            <div>
                                <span style="font-weight: bold">Inventory : </span><span>{{ loc.current}}m<sup>3</sup> / {{ loc.percentage }}%</span>

                            </div>
                            <highcharts
                                    :options="chartOptions1(loc.percentage)"
                                    class="chart-container"
                            ></highcharts>
                                                        <div>
                                <span style="font-weight: bold">Low : </span><span>{{ loc.low }}m<sup>3</sup> / </span><span style="font-weight: bold">High: </span><span>{{ loc.high }}m<sup>3</sup></span>
                            </div>
                            <div>
                                <span style="font-weight: bold">Production : </span><span>{{ loc.pro }}m<sup>3</sup></span>
                            </div>
                            <div>
                                <span style="font-weight: bold">Hours to HT: </span><span>{{ loc.ht }}hr</span>
                            </div>
                            <div>
                                <span style="font-weight: bold">Requested : </span><span>{{loc.haulsRequested}}m<sup>3</sup></span>
                            </div>
                            <div>
                                <span style="font-weight: bold">Hauled : </span><span> {{loc.current}} m<sup>3</sup></span>
                            </div>
                            <div>
                                <span style="font-weight: bold">Remaining : </span><span>{{ loc.rem }}m<sup>3</sup></span>
                            </div>
                        </b-col> 
                        <b-col sm=7>
                            <highcharts
                              :options="chart_options_1(index_1)"
                              class="chart-container"
                            >
                            </highcharts>
                         </b-col> 
                    </b-row>
                    <b-row>
							          <b-col>

                        </b-col>  
                    </b-row>                   
                    <br />
                    <b-row>
							          <b-col  sm=5>
                            <b-table show-empty empty-text="No Add/Cut"
                            :outlined="true"
                            :borderless="true"
                            :fields = "[{key: 'item', label: ' '}, {key: 'add', label: 'Add'}, {key: 'cut', label: 'Cut'}, {key: 'total', label: 'Total'}, {key: 'pending', label: 'Pending'}]" 
                            :items="volume_change" 
                            stacked="sm" 
                            small
                            >		
                            		<template slot="add" slot-scope="row">
                                  <span>&nbsp;&nbsp;&nbsp;{{volume_change[row.index].add}}</span>
                                </template>
                                <template slot="cut" slot-scope="row">
                                  <span>&nbsp;&nbsp;&nbsp;{{volume_change[row.index].cut}}</span>
                                </template>
                                <template slot="total" slot-scope="row">
                                  <span>&nbsp;&nbsp;&nbsp;{{volume_change[row.index].total}}</span>
                                </template>
						                    <template slot="pending" slot-scope="row">
                                  <span>&nbsp;&nbsp;&nbsp;{{volume_change[row.index].pending}}</span>
                                </template>
                            </b-table>
                        </b-col>  
                    </b-row>                     
                    <b-row>
							          <b-col>
                            <b-table show-empty empty-text="No Volume Change"
                            :outlined="false"
                            :borderless="true"
                            :border="false"
                            :fields = "[{key: 'createdTime', label: '  '}, {key: 'truckCo', label: '  '}, {key: 'terminal', label: '  '}, {key: 'amount', label: '  '}, {key: 'confirmation', label: '  '}]" 
                            :items="loc.volumeChanges" 
                            stacked="sm"
                            hover 
                            :no-border-collapse="false"
                            small>
                            <template slot="createdTime" slot-scope="item">
                              <span>{{date_format1(loc.volumeChanges[item.index].createdTime)}}</span>
                            </template>
                            <template slot="truckCo" slot-scope="item">
                              <span>{{map_tc(loc.volumeChanges[item.index].truckCo, maps_truckco)}}</span>
                            </template>    
                                                  <template slot="terminal" slot-scope="item">
                              <span>{{map_terminal(loc.volumeChanges[item.index].terminal)}}</span>
                            </template>                                         
                            <template slot="amount" slot-scope="item">
                              <span>35m<sup>3</sup></span>
                            </template>
                                                  <template slot="confirmation" slot-scope="item">
                                                      <b-badge v-if="loc.volumeChanges[item.index].confirmation==null"   style="background-color: #F8F32b">Pending
                                                      </b-badge>
                              <b-badge v-if="loc.volumeChanges[item.index].confirmation=='n'" style="background-color: #f3c293">Rejected
                                                      </b-badge>
                                                      <b-badge v-if="loc.volumeChanges[item.index].confirmation=='y'" style="background-color: #b7F49a">Accepted
                                                      </b-badge>
                            </template>
                            </b-table>
                        </b-col>  
                    </b-row> 
                </div>

            </div>
            <b-button class="btn btn-primary" @click="back_click()">Back</b-button>
         
        </Container>
        <b-modal no-fade centered button-size="sm" size="sm" v-model="newTC" hide-header hide-backdrop no-close-on-esc no-close-on-backdrop hide-header-close>  
            <b-row>
                <b-col >
                    <b-form-group :label-cols="1" vertical label="Trucking Company" label-for="terminalCompanies">
                        <b-form-select id="terminalCompanies" v-model="to_send_data.trucking_company" :options="trucking_companies">
                            <template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col >
                    <b-form-group :label-cols="1" vertical label="Terminal" label-for="terminal">
                        <b-form-select id="terminal" v-model="to_send_data.terminal" :options="terminals">
                            <template slot="first"><option :value="null" disabled>-- select terminal --</option></template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer" class="w-100">
                <b-button size="md" variant="secondary" @click="cancel()" class="float-left">Cancel</b-button>
                <b-button size="sm" variant="primary" @click="confirm_to()" class="float-right">Confirm</b-button>
            </div>   
        </b-modal>
      </div>
    </div>
    <!-- <div class="notes"   class="custom-checkboxes" >
	  <p><b>Notes</b></p>
	  <p>Status (high/Low/Good) is based on EOD value. 5 Possibilities.</p>
	  <ul>
	    <li><span class="red"></span>Low</li>
		<li><span class="yellow"></span>Low</li>
		<li><span class="green"></span>Good</li>
		<li><span class="yellow"></span>Hight</li>
		<li><span class="red"></span>Hight</li>
	  </ul>
	</div> -->
  </div>
</template>

<script>
import intraday_service from "./intraday_service";
import { Container, Draggable } from "vue-smooth-dnd";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

Highcharts.SVGRenderer.prototype.symbols.target = function(
  x,
  y,
  w,
  h,
  options
) {
  w = w;
  return [
    "M",
    x + w / 2 + (options.width + 4),
    y + h / 2 + (options.overlap ? 2 : 0),
    "L",
    x + w / 2 - (options.width + 4),
    y + h / 2 + (options.overlap ? 2 : 0),
    "z"
  ];
};
if (Highcharts.VMLRenderer) {
  Highcharts.VMLRenderer.prototype.symbols.target =
    Highcharts.SVGRenderer.prototype.symbols.target;
}

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};
const items = []
export default {
  name: "intraday_report",
  components: {
    Container,
    Draggable,
    highcharts: Chart
  },
  props: {},
  created: function() {
    this.getData();
  },
  data() {
    return {
        loadingData     : true,
        subTitle        : "",
        locacations_data: {},
        newTC           : false,
        to_send         : 0,
        to_send_data    : {
                                "site"              :   {"id":0},
                                "site_name"         :   '',
                                "amount"            :   0,
                                "trucking_company"  :   null,
                                "terminal"          :   null,
                                "index"             :   0,
                            },
        trucking_companies : [],
        terminals          : [],
        sign               : 'm3/+',
        no_detail          : true,
        loc                : {
                                "name"          : '',
                                "volumeChanges" :[],
                                "current"         : 0,
                                "low"             : 0,
                                "high"            : 0,
                                "pro"             : 0,
                                "ht"              : 0,
                                "haulsRequested"  : 0,          
                                "haulsDelivered"  : 0,          
                                "rem"             : 0,
                                "percentage"      : 0,
                                
                            },
        maps_truckco        : [{"name":'S.O.R.E. Oilfield Services Inc.', "map":'SORE'}, {"name":'CRUDE MASTER TRANSPORT INC.', "map":'CMT'},{"name":'Torq Trucking', "map":'TORQ'}],
        volume_change       : [],
        view                : false,
        site_levels         : {},
        index_1             : null,
        
    };
  },
  methods: {
    getData() {
      this.loadingData = true;
      intraday_service
        .getLocationsIndicatorsData()
        .then(data => {
          if (data.status=="success") {
              this.locacations_data = data.locations_indicator
              this.site_levels = data.site_levels
              this.loadingData = false
              this.view = data.view
          } else {
              this.loadingData = false
              this.view = false
          }

        })
        .catch(error => {
          this.$swal("Error", "Server not response. " + error, "error");
          this.loadingData = false
          this.view = false
        });
    },
    getCardPayload(columnId) {
      return index => {
        return this.locacations_data.locations[index];
      };
    },
    onCardDrop(columnId, dropResult) {
      const tmp = applyDrag(this.locacations_data.locations, dropResult);

      this.locacations_data.locations = tmp;
    },
    shouldAcceptDropDesktop(sourceContainerOptions, payload) {
      return true;
    },
    shouldAnimateDropDesktop(sourceContainerOptions, payload) {
      return false;
    },
    log(e) {
      // console.log(e)
    },
    getStateVariant(state) {
      let s = String(state).toLowerCase();
      if (s === "good") return "success";
      else if (s === "low") return "warning";
      else return "danger";
    },
    chartOptions(index) {
      let opts = JSON.parse(JSON.stringify(intraday_service.getChartConfig()));
      let bands_colors = [
        "#D9602F",
        "#FFD966",
        "#76716F",
        "#FFD966",
        "#D9602F"
      ];
      opts.yAxis = {
        labels: {
          format: "{value}"
        },
        title: null
      };
      //custom tooltips formatter
      opts.tooltip.formatter = function() {
        let tooltips = "";
        this.series.chart.series.forEach(serie => {
          if (
            Math.abs(this.point.y - serie.processedYData[this.point.index]) < 7
          ) {
            tooltips +=
              (tooltips.length ? "<br>" : "") +
              '<span style="color:' +
              serie.color +
              '">\u25CF</span> ' +
              serie.name +
              ": " +
              "<b>" +
              serie.processedYData[this.point.index] +
              "m<sup>3</sup></b>";
          }
        });
        return tooltips;
      };
      if (this.locacations_data.locations[index].ranges.length) {
        opts.yAxis.plotBands = [];
        this.locacations_data.locations[index].ranges.forEach((range, i) => {
          opts.yAxis.plotBands.push({
            from: range.lowerLimit,
            to:
              i == this.locacations_data.locations[index].ranges.length - 1
                ? 9e9
                : range.upperLimit,
            color: bands_colors[i]
          });
          if (i === 0) {
            opts.yAxis.min = range.lowerLimit;
          }
          if (i !== 0 && i == this.locacations_data.locations[index].ranges.length - 1) {
            opts.yAxis.max = range.upperLimit;
          }
        });
      }
      opts.series = [
        {
          name: "Low",
          data: [this.locacations_data.locations[index].low],
          color: "#364A8A",
          marker: {
            lineColor: "#364A8A"
          }
        },
        {
          name: "High",
          data: [this.locacations_data.locations[index].high],
          color: "#364A8A",
          marker: {
            lineColor: "#364A8A"
          }
        },
        {
          name: "EOD",
          data: [this.locacations_data.locations[index].eod],
          color: "#6FA64B",
          marker: {
            lineColor: "#6FA64B"
          }
        },
        {
          name: "Current",
          data: [this.locacations_data.locations[index].current],
          color: "#FFD966",
          marker: {
            lineColor: "#FFD966"
          }
        }
      ];
      
      //detect and overlapping series
      opts.series.forEach((serie, i, series) => {
        if (i > 0) {
          let j = series.findIndex(
            e => Math.abs(serie.data[0] - e.data[0]) < 6
          );
          if (j != i && j < i) {
            opts.series[i].marker.overlap = true;
          }
        }
      });

      return opts;
    },
    date_format(in_datetime) {
      var today = new Date(in_datetime); 
      var todayLess = new Date(today - (360  * 60000)); 
      return moment(today).format("YYYY/MM/DD HH:mm:ss")
    } ,
    date_format1(in_datetime) {
      var today = new Date(in_datetime); 
      var todayLess = new Date(today - (360  * 60000)); 
      return moment(today).format("MMM DD hh:mma")
    } ,
    add(index) {
        this.locacations_data.locations[index].preview = true
        this.locacations_data.locations[index].inc_1++ 
        this.locacations_data.locations[index].inc   = 35*this.locacations_data.locations[index].inc_1
        if (this.locacations_data.locations[index].inc_1==0) {
            this.locacations_data.locations[index].preview = false
        } else if (this.locacations_data.locations[index].inc_1>0) {
            this.sign  = 'm3/+'
        } else {
            this.sign  = 'm3/'
        }
    },
    minus(index) {
        this.locacations_data.locations[index].preview = true
        this.locacations_data.locations[index].inc_1--
        this.locacations_data.locations[index].inc   = 35*this.locacations_data.locations[index].inc_1
        if (this.locacations_data.locations[index].inc_1==0) {
            this.locacations_data.locations[index].preview = false
        } else if (this.locacations_data.locations[index].inc_1>0) {
            this.sign  = 'm3/+'
        } else {
            this.sign  = 'm3/'
        }
    },
    confirm (index) {
        if (this.locacations_data.locations[index].inc!=0) {
            this.newTC                  = true
            this.to_send                = this.locacations_data.locations[index].inc
            this.to_send_data.amount    = this.locacations_data.locations[index].inc_1
            this.to_send_data.site["id"]   = this.locacations_data.locations[index].id
            this.to_send_data.site_name = this.locacations_data.locations[index].name
            this.to_send_data.index     = index
            if (this.locacations_data.locations[index].truckCos.length>0) {
                this.trucking_companies     = this.locacations_data.locations[index].truckCos.map(item => { return { text: item, value: item } })
            } else {
                this.trucking_companies     = []
            }
            if (this.locacations_data.locations[index].terminals.length>0) {
                this.terminals              = this.locacations_data.locations[index].terminals.map(item => { return { text: item, value: item } })   
            } else {
                this.terminals              =  []
            }            
        }
    },
    okTo() {
        if (this.to_send_data.trucking_company==null) {
			this.$swal('Alert!', 'Trucking company not selected', 'warning')
			return false
		}
        if (this.to_send_data.terminal==null) {
			this.$swal('Alert!', 'Terminal not selected', 'warning')
			return false
		}
        return true
    },
    confirm_to () {
        if(!this.okTo()) {
          	return
		    }
        intraday_service
            .send_volumeChange(this.to_send_data)
            .then(data => {
                this.$swal(data.status, data.message, data.status)
            })
            .catch(error => {
                this.$swal("Error", "Server not response. " + error, "error");
            });
        this.locacations_data.locations[this.to_send_data.index].inc_1      = 0
        this.locacations_data.locations[this.to_send_data.index].inc        = 0
        this.locacations_data.locations[this.to_send_data.index].preview    = false
        this.cancel()
    },
    cancel() {
        this.newTC=false
        this.to_send_data    = {
                            "site"              :   {"id":0},
                            "site_name"         :   '',
                            "amount"            :   0,
                            "trucking_company"  :   null,
                            "terminal"          :   null,
                            "index"             :   0
                        }
    },
    detail (index) {
        this.loc.name           = this.locacations_data.locations[index].name
        this.loc.volumeChanges = this.locacations_data.locations[index].volumeChanges

        this.loc.current        = this.locacations_data.locations[index].current
        this.loc.low            = this.locacations_data.locations[index].low
        this.loc.high            = this.locacations_data.locations[index].high
        this.loc.pro            = this.locacations_data.locations[index].pro
        this.loc.ht             = this.locacations_data.locations[index].ht
        this.loc.haulsRequested             = this.locacations_data.locations[index].haulsRequested
        this.loc.haulsDelivered             = this.locacations_data.locations[index].haulsDelivered
        this.loc.rem             = this.locacations_data.locations[index].rem
        let max = Math.max(...this.locacations_data.locations[index].ranges.map(o => o.upperLimit), 0); 
        this.loc.percentage      = Math.round((this.loc.current/max)*100,2)
        this.no_detail  = false
        this.volume_change = []
        let item={"item":"Volume", 
                  "add":this.locacations_data.locations[index].requested.addVolume, 
                  "cut": this.locacations_data.locations[index].requested.cutVolume,
                  "total":this.locacations_data.locations[index].requested.addVolume-this.locacations_data.locations[index].requested.cutVolume,
                  "pending":this.locacations_data.locations[index].pending.volume}
        this.volume_change.push(item)
        let item1={"item":"Trucks", 
                  "add":this.locacations_data.locations[index].requested.addCount, 
                  "cut": this.locacations_data.locations[index].requested.cutCount,
                  "total":this.locacations_data.locations[index].requested.addCount-this.locacations_data.locations[index].requested.cutCount,
                  "pending":this.locacations_data.locations[index].pending.count}
        this.volume_change.push(item1)
        this.index_1 = index
    },
    map_tc (tc, items) {
        let index = items.map(o => o.name).indexOf(tc)
        let map_f = tc
		if (index > -1) {
		    map_f = items[index].map
		} 
        return map_f
    },
    map_terminal (tc) {
        let index = tc.split(" ")
        let map_f = ''
        if (index.length>1) {
            map_f =index[1]
        } else if (index.lenght==1) {
            map_f =index[0]
        }
        return map_f
    },
    chartOptions1(percentage) {
      let opts = JSON.parse(JSON.stringify(intraday_service.getChartConfig()));
      let bands_colors = [
        "#D9602F",
        "#00D966",
      ];
      opts.yAxis = {
        labels: {
          format: "{value}"
        },
        title: null
      };
        opts.yAxis.min = 0
        opts.yAxis.max = 100

        opts.yAxis.plotBands = [{
            from: 0,
            to: percentage,
            color: "#0076b9"
        },{
            from: percentage,
            to: 100,
            color: "#b5b5b5"
        }]
        
        opts.series = [
        {
          name: "1",
          data: [percentage],
          marker : { enabled:false}
        }  
      ]
      return opts
    },
    back_click() {
        this.no_detail  = true
    },
    chart_options() {
      let opts = JSON.parse(JSON.stringify(intraday_service.getChartConfig_1()));
      opts.chart= {
        type: "spline",
        height: 380,
        borderWidth: 0,
        marginBottom: 48,
        marginLeft: 45,
        plotBackgroundColor: '#EEEEEE',
        
      },
      opts.xAxis= {
        tickmarkPlacement : 'on',
        startOnTick       : true,

        minPadding        : 0.01,
        minorTicks        : true,
        
        gridLineWidth       : 0.6,
        gridLineColor     : '#B9B9B9',
  
        minorTickInterval : 'auto',
        minorTickWidth    : 1,
        minorTickLength   : 4,
        minorTickPosition : 'inside',
        minorTickColor    : '#B9B9B9',
        minorGridLineColor: '#B9B9B9',
        minorGridLineWidth: 0.4,
        crosshair         : false,
        min               :this.site_levels.ticks[0],
        tickInterval      : this.site_levels.ticks[1]-this.site_levels.ticks[0],
        tickPositions     : this.site_levels.ticks,
        labels            : {
              formatter: function () { 
                var a = new Date(this.value * 1000);
                var hour = a.getHours();
                var time = hour + ':00';
                return time; },
              rotation: -90,
        },

      },
      opts.yAxis= [
        { //--- Secondary yAxis
          title: {
              text: ''
          },
          min:0,
          max:2000,
          tickInterval: 200,
          tickPositions: [0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
          gridLineWidth: 0,
          lineWidth: 0,
          opposite: true,
        },
        { //--- Primary yAxis
          title: {
              text: ''
          },
          min : 1000,
          max :6000,
          tickInterval: 1000,
          tickPositions: [1000, 2000, 3000, 4000, 5000, 6000],
          gridLineWidth: 0.6,
          gridLineColor     : '#B9B9B9',
          labels      : {
            format: '{value:.0f}' 
          },
          lineWidth: 0,
        },
      ],
      opts.tooltip= {
        crosshairs: true,
        formatter: function () {
            var a = new Date(this.x * 1000);
            var hour = a.getHours();
            var minute = a.getMinutes();
            var time = hour + ':' + minute;
            return '<b>time:'+time+'</b><br>volume:'+this.y;
        }
      },
      opts.series = this.site_levels.series //'#FF650B'
      return opts
    },
    chart_options_1(index) {
      if (index!==null ) {
        let opts = JSON.parse(JSON.stringify(intraday_service.getChartConfig_1()));
        opts.chart= {
          type        : "spline",
          height      : 340,
          borderWidth : 0,
          marginBottom: 48,
          marginLeft  : 5,
          plotBackgroundColor: '#EEEEEE'
        
      },
        opts.xAxis= {
              tickmarkPlacement : 'on',
              startOnTick       : true,

              minPadding        : 0.01,
              minorTicks        : true,
              
              gridLineWidth       : 0.6,
              gridLineColor     : '#B9B9B9',
        
              minorTickInterval : 'auto',
              minorTickWidth    : 1,
              minorTickLength   : 4,
              minorTickPosition : 'inside',
              minorTickColor    : '#B9B9B9',
              minorGridLineColor: '#B9B9B9',
              minorGridLineWidth: 0.4,
              crosshair         : false,
              min               :this.site_levels.ticks[0],
              tickInterval      : this.site_levels.ticks[1]-this.site_levels.ticks[0],
              tickPositions     : this.site_levels.ticks,
              labels            : {
                    formatter: function () { 
                      var a = new Date(this.value * 1000);
                      var hour = a.getHours();
                      var time = hour + ':00';
                      return time; },
                    rotation: -90,
              },
        },
        opts.yAxis= [
          { 
              title: {
                  text: ''
              },
              min:0,
              max:this.site_levels.chart_control[index][0].data[0]['y']+200,
              tickInterval: 200,
              opposite: true,
              gridLineWidth: 0,
              lineWidth: 0,
          }
        ],
        opts.tooltip= {
        formatter: function () {
            var a = new Date(this.x * 1000);
            var hour = a.getHours();
            var minute = a.getMinutes();
            var time = hour + ':' + minute;
            return '<b>time:'+time+'</b><br>volume:'+this.y;
          }
        },
        opts.series = this.site_levels.chart_control[index]  // '#FF650B'
      return opts
      }
    },
      
  },  


  computed: {}
};
</script>
<style lang="scss">
@media screen and (max-width: 992px) {
  .main .container-fluid {
    padding: 10px 11px 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.location-widget {
  color: #999eab;
  border-radius: 6px;
  min-width: 300px;
  max-width: 600px;
  border: 0;
  padding: 0 !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.card.location-widget {
  border: rgba(112, 112, 112, 0.4) 1px solid;
}
.location-widget-header {
  border-bottom: 0px;
  border-radius: 0.4pt 0.4pt 0 0;
  background: transparent;
  padding: 0.5rem 0.5rem !important;
}
.location-widget-title {
  color: #707070;
  font-size: 18px;
  font-family: "Segoe UI";
  font-weight: bold;
}
.location-widget-legend {
  font-family: Roboto, "Segoe UI";
  color: #737475;
  font-size: 14px;
}
.location-widget-legend-item {
  display: inline-block;
}
.location-state {
  min-width: 90px;
  color: #ffffff;
  font-family: "Segoe UI";
  font-weight: 500;
  font-size: 18px;
  padding: 0.5rem 0.5rem !important;
}
.legend-badget {
  width: 14px;
  height: 16px;
  padding: 0.5em 0.5em !important;
}
.location-widget-chart {
  max-width: 100%;
  height: 100px;
  margin: 0;
  padding: 0;
  margin-top: 20px;
}
.card.location-widget .location-widget-legend .btn {
  color: #fff !important;
  font-size: 18px;
  padding: 11px 20px;
  background: #364a8a !important;
  border: 0 !important;
}
.badge-success {
  background: #6fa64b;
}
.badge-warning {
  background: #ffd966;
}
.badge-danger {
  background: #d9602f;
}
.notes {
  margin-bottom: 50px;
}
.notes p {
  font-size: 18px;
  margin-bottom: 0;
  color: #737475;
}
.notes p b {
  color: #707070;
}
.notes ul {
  padding: 0;
  margin: 17px 0 0;
}
.notes ul li {
  color: #737475;
  font-size: 18px;
  line-height: 10px;
  list-style: none;
  margin-bottom: 6px;
}
.notes ul li span {
  display: inline-block;
  width: 55px;
  height: 31px;
  margin: 10px 10px -10px 0;
}
.notes ul li span.red {
  background: #d9602f;
}
.notes ul li span.yellow {
  background: #ffd966;
}
.notes ul li span.green {
  background: #6fa64b;
}
@media screen and (max-width: 992px) {
  .row.pageinfo {
    display: none;
  }
  .card.location-widget {
    margin-bottom: 14px !important;
  }
  .card.location-widget .location-widget-chart {
    height: auto;
    margin-top: 0;
  }
  .card.location-widget .location-widget-legend {
    font-size: 11px;
    margin-top: 8px !important;
  }
  .legend-badget {
    height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/intraday/intraday_report.vue